import React from 'react';
import PropTypes from 'prop-types';
import MetadataObject from './MetadataObject';
import MetadataObjectArray from './MetadataObjectArray';
import MetadataSimpleArray from './MetadataSimpleArray';
import Property from '../Property';
import { boolean as booleanFormatter } from '../DataGrid/formatters';

const Metadata = ({ metadata, schema, uiSchema }) => {
  const renderMetadata = data => {
    const { key, value } = data;
    const currentSchema = schema?.properties?.[key];
    const currentUiSchema = uiSchema?.[key] ?? {};
    const { props: uiProps = {} } = currentUiSchema;
    const { label: uiLabel, ...otherUiProps } = uiProps;
    const label = uiLabel ?? currentSchema?.description ?? currentSchema?.title ?? key;
    const type = uiProps?.type ?? currentSchema?.type;

    if (Array.isArray(value)) {
      const [firstValue] = value;

      if (firstValue && typeof firstValue === 'object') {
        return (
          <MetadataObjectArray
            key={key}
            label={label}
            value={value}
            schema={currentSchema?.items ?? {}}
            {...otherUiProps}
          />
        );
      }

      return <MetadataSimpleArray key={key} label={label} value={value} {...otherUiProps} />;
    }

    if (value && typeof value === 'object') {
      return (
        <MetadataObject
          key={key}
          label={label}
          value={value}
          schema={currentSchema}
          {...otherUiProps}
        />
      );
    }

    if (type === 'boolean' || typeof value === 'boolean') {
      return <Property key={key} label={label} value={booleanFormatter(value)} {...otherUiProps} />;
    }

    return <Property key={key} label={label} value={value} {...otherUiProps} />;
  };

  return Object.keys(metadata).map(key => renderMetadata({ key, value: metadata[key] }));
};

Metadata.propTypes = {
  metadata: PropTypes.object,
  schema: PropTypes.object,
  uiSchema: PropTypes.object,
};

Metadata.defaultProps = {
  metadata: {},
  schema: {},
  uiSchema: {},
};

export default Metadata;
